module.exports = __webpack_public_path__ + "img/symbol_5.abc7f567.png";